export interface UserData {
  userDetails: any;
  localLanguage: any;
  allApiLinks: any;
  loginDetails: any;
  otpVerifiedDetails: any;
  businessDetails: any;
  usersList: any;
  selectedUser: any;
  permissionData: any;
  dashboardDetails: any;
  tempararyAddUserFormData: any;
}

export interface Login {
  otp: any;
}
export const initialAuthState: UserData = {
  userDetails: {},
  allApiLinks: {},
  loginDetails: {},
  otpVerifiedDetails: {},
  businessDetails: {},
  usersList: {},
  selectedUser: {},
  localLanguage: {},
  permissionData: [],
  dashboardDetails: {},
  tempararyAddUserFormData: {},
};
